// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5b40e589","404":"74fc24c3","498":"ea05fd58"}[chunkId] + ".chunk.js";
};